export default {
  CLEAR_TASK: 'CLEAR_TASK',
  COMPLETE_CALL: 'COMPLETE_CALL',
  COMPLETE_TASK: 'COMPLETE_TASK',
  WRAPPING_TASK: 'WRAPPING_TASK',
  GET_AGENT_TOKEN: 'GET_AGENT_TOKEN',
  GET_AGENT_CAPABILITY_TOKEN: 'GET_AGENT_CAPABILITY_TOKEN',
  GET_PENDING_TASKS: 'GET_PENDING_TASKS',
  GET_TASK: 'GET_TASK',
  GET_CALL: 'GET_CALL',
  GET_CALL_ID: 'GET_CALL_ID',
  POLL_CALL_AUDIO_FEEDBACK: 'POLL_CALL_AUDIO_FEEDBACK',
  INIT_WORKER: 'INIT_WORKER',
  LOGIN: 'LOGIN',
  LOGIN_SOCIAL: 'LOGIN_SOCIAL',
  LOGOUT: 'LOGOUT',
  SESSION_OFF: 'SESSION_OFF',
  SESSION_ON: 'SESSION_ON',
  SESSION: 'SESSION',
  SET_AVAILABILITY: 'SET_AVAILABILITY',
  SET_USER_DATA: 'SET_USER_DATA',
  START_CALL: 'START_CALL',
  START_RECORDING: 'START_RECORDING',
  STOP_CALL: 'STOP_CALL',
  STOP_RECORDING: 'STOP_RECORDING',
  WORKER_READY: 'WORKER_READY',
  INIT_DEVICE: 'INIT_DEVICE',
  DEVICE_READY: 'DEVICE_READY',
  JOB_ACTIVATE: 'JOB_ACTIVATE',
  JOB_GET_ALL: 'JOB_GET_ALL',
  GET_JOB_AGENT_SOW: 'GET_JOB_AGENT_SOW',
  GET_JOB_AGENT_HITS: 'GET_JOB_AGENT_HITS',
  SIGN_JOB_AGENT_SOW: 'SIGN_JOB_AGENT_SOW',
  GET_AGENT_IS_VENDOR: 'GET_AGENT_IS_VENDOR',
  GET_AGENT_TOU_ACCEPTANCE: 'GET_AGENT_TOU_ACCEPTANCE',
  SIGN_AGENT_TOU_ACCEPTANCE: 'SIGN_TOU_ACCEPTANCE',
  GET_AGENT_PROFILE: 'GET_AGENT_PROFILE',
  SAVE_AGENT_PHONE_NUMBER: 'SAVE_AGENT_PHONE_NUMBER',
  GET_AGENT_METRICS: 'GET_AGENT_METRICS',
  SET_APPLICATION_NOTIFICATION: 'SET_APPLICATION_NOTIFICATION',
  SET_METRICS_DURATION: 'SET_METRICS_DURATION'
};
